/**
 * @generated SignedSource<<ded6d36b81a6327a53114cd427635c3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventPeopleRendererQuery$variables = {
  orgRelayId: string;
  externalEventId: string;
};
export type EventPeopleRendererQuery$data = {
  readonly org: {
    readonly " $fragmentSpreads": FragmentRefs<"EventPeople_org">;
  } | null;
};
export type EventPeopleRendererQuery = {
  variables: EventPeopleRendererQuery$variables;
  response: EventPeopleRendererQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "externalEventId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orgRelayId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "orgRelayId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "externalEventId",
    "variableName": "externalEventId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "focusTimeMinutesCost",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EventPeopleRendererQuery",
    "selections": [
      {
        "alias": "org",
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v3/*: any*/),
                "kind": "FragmentSpread",
                "name": "EventPeople_org"
              }
            ],
            "type": "Org",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "EventPeopleRendererQuery",
    "selections": [
      {
        "alias": "org",
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "experiments",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "computeCurrentSlotImpactErrorable",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "statusCode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "message",
                        "storageKey": null
                      }
                    ],
                    "type": "GraphEntityError",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SchedulingSlot",
                        "kind": "LinkedField",
                        "name": "currentSlot",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SchedulingAttendanceSummary",
                            "kind": "LinkedField",
                            "name": "summary",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "conflictingAttendees",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "unavailableAttendees",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "inconvenientForAttendees",
                                "storageKey": null
                              },
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SchedulingAttendanceImpact",
                            "kind": "LinkedField",
                            "name": "attendanceImpacts",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasConflict",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "calendarId",
                                "storageKey": null
                              },
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "inconveniences",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "unavailabilities",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "conflictingMeetings",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "uncrawledCalendars",
                        "storageKey": null
                      }
                    ],
                    "type": "CurrentScheduledSlotImpact",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Org",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9cc12778a6246359d5a9cc3f8c4ab883",
    "id": null,
    "metadata": {},
    "name": "EventPeopleRendererQuery",
    "operationKind": "query",
    "text": "query EventPeopleRendererQuery(\n  $orgRelayId: ID!\n  $externalEventId: String!\n) {\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      ...EventPeople_org_2QwfB1\n    }\n    id\n  }\n}\n\nfragment EventPeople_org_2QwfB1 on Org {\n  id\n  experiments\n  computeCurrentSlotImpactErrorable(externalEventId: $externalEventId) {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on CurrentScheduledSlotImpact {\n      currentSlot {\n        summary {\n          conflictingAttendees\n          unavailableAttendees\n          inconvenientForAttendees\n          focusTimeMinutesCost\n        }\n        attendanceImpacts {\n          hasConflict\n          calendarId\n          focusTimeMinutesCost\n          inconveniences\n          unavailabilities\n          conflictingMeetings\n        }\n      }\n      uncrawledCalendars\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9d641d5f4452957191251704ded6ce4e";

export default node;
